import posthog from "posthog-js";

export function readPosthogDistinctId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    return posthog.get_distinct_id();
  } catch {
    return undefined;
  }
}
